// Import container components
import NavbarContainer from './NavbarContainer';
import FooterContainer from './FooterContainer';
import ScrollToTopContainer from './ScrollToTopContainer';

// Re-export container components as the public API
export const Navbar = NavbarContainer;
export const Footer = FooterContainer;
export const ScrollToTop = ScrollToTopContainer;

// Also export the presentational components for testing and documentation
export { default as NavbarPresentation } from './NavbarPresentation';
export { default as FooterPresentation } from './FooterPresentation';
export { default as ScrollToTopPresentation } from './ScrollToTopPresentation';
export { default as NavLink } from './NavLink';